/**
 * Typography for rendered compliance-message HTML. The rich-text editor and the admin preview use
 * the same rules, so the preview looks like what was typed (and like the member dashboard's card).
 * Kept apart from RichTextEditor so pages can style HTML without loading the editor.
 */
export const richTextContentSx = {
  overflowWrap: 'anywhere',
  lineHeight: 1.6,
  '& p': { m: 0, mb: 1 },
  '& h2, & h3, & h4': { m: 0, mt: 1.5, mb: 1, fontWeight: 700, lineHeight: 1.3 },
  '& h2': { fontSize: '1.25rem' },
  '& h3': { fontSize: '1.125rem' },
  '& h4': { fontSize: '1rem' },
  '& ul, & ol': { m: 0, mb: 1, pl: 3 },
  '& ul': { listStyleType: 'disc' },
  '& ul ul': { listStyleType: 'circle' },
  '& ul ul ul': { listStyleType: 'square' },
  '& ol': { listStyleType: 'decimal' },
  '& ol ol': { listStyleType: 'lower-alpha' },
  '& ol ol ol': { listStyleType: 'lower-roman' },
  '& li > p': { mb: 0.25 },
  '& li > ul, & li > ol': { mb: 0 },
  '& blockquote': {
    m: 0,
    mb: 1,
    pl: 2,
    py: 0.25,
    borderLeft: '4px solid',
    borderLeftColor: 'divider',
    color: 'text.secondary',
  },
  '& blockquote > :last-child': { mb: 0 },
  '& a': { color: 'primary.main', textDecoration: 'underline' },
  '& > :first-child': { mt: 0 },
  '& > :last-child': { mb: 0 },
};
